import { render, staticRenderFns } from "./Insuentradas.vue?vue&type=template&id=81e6ce56"
import script from "./Insuentradas.vue?vue&type=script&lang=js"
export * from "./Insuentradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports